import {createContext, useContext} from "react";
import {IToast} from "./mainProvider";

type MainContextType = {
    isLoading: boolean;
    setLoading: (isLoading: boolean) => void;
    createToast: (toast: IToast) => void;
    getToast: () => React.ReactElement,
    createErrorToast: (message: string, title?: string) => void;
}

export const MainContext = createContext<MainContextType | undefined>(undefined);

export const useMain = () => {
    const context = useContext(MainContext);
    if (!context) {
        throw new Error('useMain must be used within a MainProvider');
    }
    return context;
}